enum LowInventoryAlertScope {
    Global = 'gl',
    Custom = 'cust',
    None = 'none',
}

export default LowInventoryAlertScope;
